import * as React from 'react';
import {
  NoBordersTable,
  StyledTd,
} from 'src/components/atomsLegacy/NoBordersTable';
import { FormattedNamedOffender } from 'src/components/pages/Case/helpers/namedOffender';
import styled from 'styled-components';

export interface SubjectsOfReportsListProps {
  redirectTo: (redirectTo: string) => void;
  namedOffenders: FormattedNamedOffender[];
  'data-testid'?: string;
}

export const SubjectsOfReportsList: React.FC<SubjectsOfReportsListProps> = ({
  redirectTo,
  namedOffenders,
  ...props
}) => (
  <NoBordersTable
    tableStyle={{ marginTop: '4px' }}
    data-testid={`${props['data-testid']}-table`}
  >
    <tbody>
      {namedOffenders.map((offender) => (
        <tr
          key={offender.id}
          data-testid={`${props['data-testid']}-${offender.name}`}
        >
          <StyledTd width="50%">{offender.name}</StyledTd>
          <StyledTd>
            <StyledReportIdsContainer>
              reports:{' '}
              <StyledReportIds>
                {offender.reports.map(({ id: reportId }, index) => (
                  <StyledReportId key={reportId}>{`${reportId}${
                    index < offender.reports.length - 1 ? ', ' : ''
                  }`}</StyledReportId>
                ))}
              </StyledReportIds>
            </StyledReportIdsContainer>
          </StyledTd>
        </tr>
      ))}
    </tbody>
  </NoBordersTable>
);

const StyledReportIds = styled.div`
  display: flex;
  flex-direction: row;
  height: 30px;
`;

const StyledReportId = styled.div`
  color: ${(props) => props.theme.newPalette.turquoise.T300};
  text-decoration: underline;
  display: flex;
  flex-direction: row;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

const StyledReportIdsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: pre;
`;
